import {put, takeEvery} from 'redux-saga/effects';
import axios from 'axios';
import * as actionTypes from 'redux/action-types.js';
import {API_URL} from '@constants/index';
import {requestSucceeded} from 'actions/general.actions';

/**
 * Login, get passport token to access apis
 */
function* login(action) {
  try {
    let formData = new FormData();

    formData.append('email', action.email);
    formData.append('password', action.password);

    let payload;
    yield axios({
      method: 'POST',
      url: API_URL + '/login',
      data: formData,
    }).then((response) => (payload = response.data));
    localStorage.setItem('menuName','Dashboard')
    yield put({ type: actionTypes.SET_LOGIN_DATA, payload });
  } catch (error) {
    let payload = error.response.data;
    yield put({ type: actionTypes.SET_LOGIN_DATA, payload });
  }
}

/**
 * Get profile data
 */
function* getProfileData(action) {
  try {
    let user;
    let roles;
    let permissions;
    let permissionGroups;
    let authUserTeam;
    let routeCan;
    let csrfToken;
    yield axios({
      method: 'GET',
      url: API_URL + '/detail',
      headers: {
        Authorization: 'Bearer ' + action.token,
      },
    }).then((response) => {
      let data = response.data;
      user = data.user;
      roles = data.roles;
      permissions = data.permissions;
      permissionGroups = data.permissionGroups;
      authUserTeam = data.authUserTeam;
      routeCan = data.routeCan;
      csrfToken = data.csrfToken;
    });
    yield put({ type: actionTypes.SET_PROFILE_DATA, user });
    yield put({ type: actionTypes.SET_ROLES_DATA, roles });
    yield put({ type: actionTypes.SET_PERMISSIONS_DATA, permissions });
    yield put({ type: actionTypes.SET_PERMISSIONS_GROUP_DATA, permissionGroups });
    yield put({ type: actionTypes.SET_AUTH_USER_TEAM, authUserTeam });
    yield put({ type: actionTypes.SET_ROUTE_CAN, routeCan });
    yield put({ type: actionTypes.SET_CSRF_TOKEN, csrfToken });
    yield put({ type: actionTypes.SET_SHOW_LOADER, data: false});
  } catch (error) {
    yield put({ type: actionTypes.SET_SHOW_LOADER, data: false});
  }
}

/**
 * Get profile data
 */
function* getNotifications(action) {
  try {
    let actionNotifications;
    let generalNotifications;
    yield axios({
      method: 'GET',
      url: API_URL + '/notifications',
      headers: {
        Authorization: 'Bearer ' + action.token,
      },
    }).then((response) => {
      let data = response.data.data;
      actionNotifications = data.actionNotifications;
      generalNotifications = data.generalNotifications;
    });

    yield put({
      type: actionTypes.SET_ACTION_NOTIFICATIONS,
      actionNotifications,
    });
    yield put({
      type: actionTypes.SET_GENERAL_NOTIFICATIONS,
      generalNotifications,
    });
  } catch (error) {}
}

/**
 * Get user modules
 */
function* getModules(action) {
  try {
    let data;
    yield axios({
      url: API_URL + '/dealer/modules',
      headers: {
        Authorization: 'Bearer ' + action.token,
      },
    }).then((response) => {
      data = response.data.data;
    });

    yield put(requestSucceeded(action.type, data));
  } catch (error) {}
}

/**
 * Initialize all data for logout
 */
function* emptyState() {
  try {
    let payload = {};
    yield put({ type: actionTypes.SET_EMPTY_STATE, payload });
  } catch (error) {}
}
export default function* watcherSaga() {
  yield takeEvery(actionTypes.LOGIN, login);
  yield takeEvery(actionTypes.EMPTY_STATE, emptyState);
  yield takeEvery(actionTypes.GET_PROFILE_DATA, getProfileData);
  yield takeEvery(actionTypes.GET_NOTIFICATIONS, getNotifications);
  yield takeEvery(actionTypes.GET_MODULES, getModules);
}
